import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Navigation } from 'swiper';
import { Link } from 'react-router-dom';
import LightBox from 'components/LightBox';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import useGa from 'hooks/useGa';

const Tabs = (props) => {
    const gaTracking = useGa();
    const location = useLocation();
    const { className, style, defaultValue, value, to, onChange, children, themeData } = props;
    const [ voteNotOpenLightbox, setVoteNotOpenLightbox ] = useState(false);
    const [ defaultTab, setDefaultTab ] = useState("");
    const [ swiper, setSwiper ] = useState(null);

    useEffect(() => {
        let index = 0;
        if(value){
            index = value.substr(value.length - 1)-1;
        }
        if(swiper){
            swiper.slideTo(index);
        }
    }, [swiper, value])

    useEffect(() => {
        setDefaultTab(defaultValue());
    }, [themeData])

    useEffect(() => {
        onChange(defaultTab);
    }, [defaultTab]);

    const handleClick = (index) => {
        gaTracking(`vote-round${index+1}`);
        themeData.theme_list[index].type === "none" ? setVoteNotOpenLightbox(true) : onChange(`#vote${index+1}`);
    }

    return (<>
        <div className="vote-tab-list">
            <Swiper
                modules={[Navigation]}
                slidesPerView="auto"
                className="vote-swiper"
                initialSlide={themeData.open_round-1 >= 0 ? themeData.open_round-1 : 0}
                navigation={{
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                }}
                onSwiper={setSwiper}
            >
                <SwiperSlide className={`${className ? ` ${className}` : ''}${value === "#vote1" ? ` active` : ''}`} onClick={() => handleClick(0)}>
                    <div className="vote-link">
                        <div>8/15 - 8/19</div>
                        <div>烤宴夥伴題</div>
                    </div>
                </SwiperSlide>
                <SwiperSlide className={`${className ? ` ${className}` : ''}${value === "#vote2" ? ` active` : ''}`} onClick={() => handleClick(1)}>
                    <div className="vote-link">
                        <div>8/20 - 8/25</div>
                        <div>烤宴健康題</div>
                    </div>
                </SwiperSlide>
                <SwiperSlide className={`${className ? ` ${className}` : ''}${value === "#vote3" ? ` active` : ''}`} onClick={() => handleClick(2)}>
                    <div className="vote-link">
                        <div>8/26 - 8/31</div>
                        <div>烤宴解膩題</div>
                    </div>
                </SwiperSlide>
                <SwiperSlide className={`${className ? ` ${className}` : ''}${value === "#vote4" ? ` active` : ''}`} onClick={() => handleClick(3)}>
                    <div className="vote-link">
                        <div>9/01 - 9/06</div>
                        <div>烤宴搭酒題</div>
                    </div>
                </SwiperSlide>
                <SwiperSlide className={`${className ? ` ${className}` : ''}${value === "#vote5" ? ` active` : ''}`} onClick={() => handleClick(4)}>
                    <div className="vote-link">
                        <div>9/07 - 9/12</div>
                        <div>烤宴告白題</div>
                    </div>
                </SwiperSlide>
                <div className="swiper-button-prev" onClick={() => gaTracking("vote-swiper-prev")}></div>
                <div className="swiper-button-next" onClick={() => gaTracking("vote-swiper-next")}></div>
            </Swiper>
        </div>
        <LightBox
            open={voteNotOpenLightbox}
            callback={() => setVoteNotOpenLightbox(false)}
            className="custom-light-box"
            cross
        >
            <div className="light-box-header vote-not-open"></div>
        </LightBox>
    </>)
}

export default Tabs;